export default __webpack_public_path__ + "static/media/picture-not-available.df48587b.jpg";